import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function WinterQuinoaSalad() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Winter Quinoa Salad</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>1 cup uncooked quinoa
        <br></br>1 medium sized butternut squash, peeled, seeded and diced
        <br></br>3 teaspoons olive oil<br></br>1 (15 oz) can chickpeas, or 1 1/2
        cups<br></br>4 cups baby kale leaves<br></br>
        1/2 cup dried cranberries or cherries<br></br>
        1/2 cup toasted chopped walnuts<br></br>
        Salt and pepper<br></br>
        <b>Dressing:</b>
        <br></br>
        1/2 cup olive oil<br></br>3 tablespoons apple cider vinegar<br></br>
        1/2 teaspoon dijon mustard<br></br>
        1/2 teaspoon minced garlic<br></br>
        1/2 teaspoon dried oregano<br></br>
        1/2 teaspoon salt<br></br>
        1/4 teaspoon pepper<br></br>
      </Typography>

      <Typography>
        Cook quinoa according to package directions. <br></br>
        Once finished cooking, fluff with a fork and add to a large bowl.
        <br></br>
        <br></br>
        Pre-heat oven to 400 degrees F. <br></br>
        On a large sheet pan, toss together the diced butternut squash, olive
        oil and salt and pepper. <br></br>
        Bake until fork tender, about 40 minutes, depending on how big they are.
        <br></br>
        <br></br>
        Add the butternut squash, chickpeas, kale, dried cranberries and walnuts
        to the bowl with quinoa and mix until combined.<br></br>
        <br></br>
        Add all dressing ingredients to a small bowl or jar and whisk until
        combined.<br></br>
        <br></br>
        Pour desired amount of dressing over salad and toss. <br></br>
        Season with salt and pepper to taste.<br></br>
      </Typography>
    </Card>
  );
}
